export default __webpack_public_path__ + "static/media/connect.de5340b1.png";